import { IMAGES } from "./site";

export const SOLUTIONS = [
  {
    slug: "residential-solar",
    name: "Residential Solar",
    title: "Residential Rooftop Solar",
    tagline: "Power Your Home with the Sun",
    image: IMAGES.solutions.residential,
    intro:
      "A rooftop solar system can help residential customers generate their own electricity using available rooftop space. We provide complete residential rooftop solar solutions from site inspection to after-sales support.",
    includes: [
      "Site inspection",
      "Electricity consumption analysis",
      "Solar capacity recommendation",
      "Rooftop assessment",
      "Solar panel installation",
      "Inverter installation",
      "Mounting structure",
      "DC/AC electrical works",
      "Earthing and protection systems",
      "Net-metering assistance",
      "Commissioning",
      "After-sales support",
    ],
    suitableTitle: "Suitable For",
    suitable: [
      "Individual houses",
      "Villas",
      "Independent homes",
      "Apartments",
      "Residential buildings",
      "Small residential communities",
    ],
    cta: "GET FREE SITE ASSESSMENT",
  },
  {
    slug: "commercial-solar",
    name: "Commercial Solar",
    title: "Commercial Rooftop Solar",
    tagline: "Cut Your Business Electricity Costs",
    image: IMAGES.solutions.commercial,
    intro:
      "Reduce your commercial property's dependence on conventional grid electricity by utilising your available rooftop space for solar generation.",
    includes: [
      "Site survey",
      "Energy analysis",
      "System design",
      "Detailed proposal",
      "Professional installation",
      "Commissioning",
      "Ongoing support",
    ],
    suitableTitle: "We Design & Install For",
    suitable: [
      "Shops & showrooms",
      "Offices",
      "Hotels",
      "Schools",
      "Hospitals",
      "Warehouses",
      "Commercial buildings",
      "Institutions",
      "Apartment common areas",
    ],
    cta: "GET COMMERCIAL SOLAR QUOTE",
  },
  {
    slug: "industrial-solar",
    name: "Industrial Solar",
    title: "Industrial Solar Power Plants",
    tagline: "Solar Energy for Heavy Daytime Loads",
    image: IMAGES.solutions.industrial,
    intro:
      "Industrial facilities often have significant daytime electricity consumption, making rooftop and ground-mounted solar an important option for reducing grid electricity requirements. DHIYAA SOLAR ENERGY provides customised solar solutions for industrial applications.",
    includes: [
      "Load analysis",
      "Energy consumption study",
      "Rooftop/land survey",
      "Shadow analysis",
      "Solar plant design",
      "Electrical design",
      "Module selection",
      "Inverter selection",
      "Mounting structure",
      "AC/DC installation",
      "Protection systems",
      "Monitoring",
      "Commissioning",
      "Maintenance",
    ],
    suitableTitle: "Suitable For",
    suitable: [
      "Manufacturing units",
      "Factories",
      "Industrial buildings",
      "Warehouses",
      "Workshops",
      "Processing units",
      "Large commercial facilities",
    ],
    cta: "DISCUSS YOUR INDUSTRIAL PLANT",
  },
  {
    slug: "solar-pump-sets",
    name: "Solar Pump Sets",
    title: "Solar Water Pumping Solutions",
    tagline: "Harness Solar Energy for Agriculture & Water",
    image: IMAGES.solutions.pump,
    intro:
      "Use solar energy for water pumping applications and reduce dependence on conventional electricity or diesel-powered pumping.",
    includes: [
      "Solar PV panels",
      "Solar pump controller",
      "Solar water pump",
      "Mounting structure",
      "DC/AC electrical system",
      "Protection equipment",
      "Cabling",
      "Installation and commissioning",
    ],
    suitableTitle: "Designed For",
    suitable: [
      "Agriculture",
      "Irrigation",
      "Borewell pumping",
      "Open-well pumping",
      "Water transfer",
      "Farm applications",
      "Rural water supply",
      "Livestock water requirements",
    ],
    cta: "ENQUIRE ABOUT SOLAR PUMP",
  },
  {
    slug: "on-grid-solar",
    name: "On-Grid Solar",
    title: "On-Grid Solar Power System",
    tagline: "Solar That Works With the Grid",
    image: IMAGES.hero[0],
    intro:
      "An on-grid solar system works along with the electricity grid. Solar panels generate electricity during sunlight hours. The generated power is used by the property, while surplus generation can be exported to the grid subject to applicable regulations and metering arrangements.",
    includes: [
      "Solar PV modules",
      "Grid-connected inverter",
      "Mounting structure",
      "DCDB",
      "ACDB",
      "DC/AC cables",
      "Earthing system",
      "Lightning protection",
      "Monitoring system",
      "Metering / net-metering arrangements where applicable",
    ],
    suitableTitle: "Key Benefits",
    suitable: [
      "Reduced grid electricity consumption",
      "Utilisation of rooftop space",
      "Low routine maintenance",
      "Clean electricity generation",
      "Long-term energy savings",
    ],
    cta: "GET ON-GRID QUOTE",
  },
  {
    slug: "hybrid-solar",
    name: "Hybrid Solar",
    title: "Hybrid Solar System",
    tagline: "Solar + Battery Backup + Grid",
    image: IMAGES.hero[1],
    intro:
      "Hybrid solar systems combine solar generation with battery storage and grid power. They are suitable where customers require solar energy, backup power and grid connectivity together.",
    includes: [
      "Solar power generation",
      "Battery backup",
      "Grid integration",
      "Intelligent energy management",
      "Backup during grid interruptions",
    ],
    suitableTitle: "Typical Applications",
    suitable: [
      "Homes",
      "Offices",
      "Shops",
      "Clinics",
      "Small commercial establishments",
      "Critical electrical loads",
    ],
    cta: "GET HYBRID QUOTE",
  },
  {
    slug: "off-grid-solar",
    name: "Off-Grid Solar",
    title: "Off-Grid Solar System",
    tagline: "Power Beyond the Grid",
    image: IMAGES.hero[2],
    intro:
      "Off-grid solar systems are designed for locations where grid electricity is unavailable, unreliable or unsuitable for the application.",
    includes: [
      "Solar PV modules",
      "Off-grid inverter",
      "Battery bank",
      "Mounting structure",
      "Electrical protection systems",
      "Installation and commissioning",
    ],
    suitableTitle: "Applications",
    suitable: [
      "Remote locations",
      "Farmhouses",
      "Agricultural areas",
      "Rural applications",
      "Remote buildings",
      "Telecom / communication applications",
      "Stand-alone power requirements",
    ],
    cta: "GET OFF-GRID QUOTE",
  },
];
